var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSearchFilled = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 26,
    fill: "currentColor",
    viewBox: "0 0 27 26",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.378 10.198C1.378 5.116 5.513 1 10.618 1s9.24 4.116 9.24 9.198a9.137 9.137 0 0 1-2.12 5.864l7.64 7.605L24.04 25l-7.651-7.617a9.228 9.228 0 0 1-5.771 2.013c-5.105 0-9.24-4.116-9.24-9.198Zm16.586 0c0-4.035-3.292-7.313-7.346-7.313-4.053 0-7.346 3.278-7.346 7.313s3.293 7.313 7.346 7.313 7.346-3.278 7.346-7.313Z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSearchFilled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/SearchFilled.8c1ee6201b43d13f2c847cb6ee7f9224.svg";